"use strict";
var transform = require('common/transform');
var documenteditorCtrl = function($scope, $timeout, $http) {
  var setEnsemble = function(oldFields, newFields, onlyBlank) {
    for (var key in oldFields) {
      if (key == 'archivnr' || key == 'ensemblenr') {
        newFields[key] = oldFields[key];
        continue;
      }
      if (typeof newFields[key] != 'undefined') {
        if (onlyBlank == true && oldFields[key].entries.length > 1 && oldFields[key].entries[0].value.length != 0) {
          continue;
        }
        oldFields[key] = newFields[key];
      }
    }
    ;
  };
  $scope.setEnsemble = function(entry, onlyBlank) {
    if (entry.value.length == 0 || entry.notFound == true) {
      return;
    }
    $http.get('/api/work/' + entry.value + '.json').then(function(response) {
      var fields = transform.fromSchema(JSON.parse(schema), response.data);
      setEnsemble($scope.data, fields, onlyBlank);
      $scope.data = fields;
    });
  };
  $scope.fieldIsSet = function(field) {
    if (field.entries.length < 1 || (field.entries.length == 1 && field.entries[0].value.trim().length == 0)) {
      return false;
    }
    return true;
  };
};
documenteditorCtrl.$inject = ["$scope", '$timeout', '$http'];
module.exports = documenteditorCtrl;
